import classnames from 'classnames';
import { DateTime } from 'luxon';
import * as React from 'react';
import Select from 'react-select';
import DatePicker from "react-widgets/DatePicker";
import "react-widgets/styles.css";
import { Col, Collapse, FormFeedback, FormGroup, Input, Label, Row } from 'reactstrap';
import utilityHelper from '../../utils/utilityHelper';
import dateHelper from '../../utils/dateHelper';
import Swal from 'sweetalert2';

const EntityStatusEditor = (props: any) => {

    //TODO source this with 
    let statusOptions: Array<{ value: string; label: string; }> = [
        { value: "0", label: "" },
        { value: "ACTIVE", label: "Active" },
        { value: "DISSOLVED", label: "Dissolved" },
        { value: "INACTIVE", label: "Inactive" }
    ];

    let editStatusOptions: Array<{ value: string; label: string; }> = [
        { value: "0", label: "" },
        { value: "ACTIVE", label: "Active" },
        { value: "DISSOLVED", label: "Dissolved" },
        { value: "INACTIVE", label: "Inactive" },
        { value: "RENAMED", label: "Renamed" },
        { value: "MERGED", label: "Merged" },
    ];


    //defaults
    const defaultEntityStatusOption = { value: "0", label: "" };

    //local hooks
    const [selectedEntityStatus, setSelectedEntityStatus]
        = React.useState<{ value: string; label: string }>
            (defaultEntityStatusOption);

    const [dissolvedDateFadeIn, setDissolvedDateFadeIn] = React.useState<boolean>(false);
    const [inactiveDateFadeIn, setInactiveDateFadeIn] = React.useState<boolean>(false);
    const [reactivateDateFadeIn, setReactivateDateFadeIn] = React.useState<boolean>(false);
    const [renamedDateFadeIn, setRenamedDateFadeIn] = React.useState<boolean>(false);
    const [mergedDateFadeIn, setMergedDateFadeIn] = React.useState<boolean>(false);

    //functions
    const handleEntityStatusChange = (selectItem: { value: string; label: string }) => {
        setSelectedEntityStatus(selectItem);
        props.setEntityStatus(selectItem.value);
        if (selectItem.label.toUpperCase() != "DISSOLVED" &&
            selectItem.label.toUpperCase() != "INACTIVE" &&
            selectItem.label.toUpperCase() != "RENAMED" &&
            selectItem.label.toUpperCase() != "MERGED"  
        ) 
          {
            setDissolvedDateFadeIn(false);
            setInactiveDateFadeIn(false);
            setRenamedDateFadeIn(false);
            setMergedDateFadeIn(false);
            if (props.status != "ACTIVE" && props.canReactivate == true) {
                setReactivateDateFadeIn(true);
            }
        }
        else {
            if (selectItem.label.toUpperCase() == "DISSOLVED") {
                props.setDissolvedDate(DateTime.now().toString());
                handleDissolvedDateChange(DateTime.now());
                setDissolvedDateFadeIn(true);
                setInactiveDateFadeIn(false);
                setReactivateDateFadeIn(false);
                setRenamedDateFadeIn(false);
                setMergedDateFadeIn(false);
            }
            else if (selectItem.label.toUpperCase() == "INACTIVE") {
                props.setInactiveDate(DateTime.now().toString());
                handleInactiveDateChange(DateTime.now());
                setInactiveDateFadeIn(true);
                setDissolvedDateFadeIn(false);
                setReactivateDateFadeIn(false);
                setRenamedDateFadeIn(false);
                setMergedDateFadeIn(false);
            }
            else if (selectItem.label.toUpperCase() == "RENAMED") {
                props.setRenamedDate(DateTime.now().toString());
                handleRenamedDateChange(DateTime.now());
                setRenamedDateFadeIn(true);
                setInactiveDateFadeIn(false);
                setDissolvedDateFadeIn(false);
                setReactivateDateFadeIn(false);
                setMergedDateFadeIn(false);
            }
            else if (selectItem.label.toUpperCase() == "MERGED") {
                props.setMergedDate(DateTime.now().toString());
                handleMergedDateChange(DateTime.now());
                setMergedDateFadeIn(true);
                setInactiveDateFadeIn(false);
                setDissolvedDateFadeIn(false);
                setReactivateDateFadeIn(false);
                setRenamedDateFadeIn(false);
            }
        }
    }

    const handleDissolvedDateChange = (value: any) => {
        if (value && dateHelper.isValidDate(value.toString())) {
            let isoDateValue:string = dateHelper.formatDateToISO(value.toString());
            props.setDissolvedDate(isoDateValue);
        }
    }

    const handleInactiveDateChange = (value: any) => {
        if (value && dateHelper.isValidDate(value.toString())) {
            let isoDateValue: string = dateHelper.formatDateToISO(value.toString());
            props.setInactiveDate(isoDateValue);
        }
    }

    const handleReactivationDateChange = (value: any) => {
        if (props.canReactivate && value && dateHelper.isValidDate(value.toString())) {
            let isoDateValue: string = dateHelper.formatDateToISO(value.toString());
            props.setReactivateDate(isoDateValue);
        }
    }

    const handleRenamedDateChange = (value: any) => {
        if (value && dateHelper.isValidDate(value.toString())) {
            let isoDateValue: string = dateHelper.formatDateToISO(value.toString());
            props.setRenamedDate(isoDateValue);
        }
    }

    const handleMergedDateChange = (value: any) => {
        if (value && dateHelper.isValidDate(value.toString())) {
            let isoDateValue: string = dateHelper.formatDateToISO(value.toString());
            props.setMergedDate(isoDateValue);
        }
    }

    React.useEffect(() => {
        if (props.status) {
            var selectedEntityStatus = props.enableAllEntityStatus == true ? editStatusOptions.find(status => status.label.toUpperCase() == props.status) :   statusOptions.find(status => status.label.toUpperCase() == props.status);
            if (selectedEntityStatus) {
                handleEntityStatusChange(selectedEntityStatus);
            }
            else {
                handleEntityStatusChange(defaultEntityStatusOption);
            }
            if (props.dissolvedDate) {
                handleDissolvedDateChange(props.dissolvedDate)
            }
            if (props.inactiveDate) {
                handleInactiveDateChange(props.inactiveDate)
            }
            if (props.reactivateDate && props.canReactivate) {
                handleReactivationDateChange(props.reactivateDate)
            }
            if (props.renamedDate) {
                handleRenamedDateChange(props.renamedDate)
            }
            if (props.mergedDate) {
                handleMergedDateChange(props.mergedDate)
            }

        }

    }, [props])

    return (
        <React.Fragment>
            <FormGroup>
                <Row>
                    <Col>
                        <Label>Entity Status:</Label>
                    </Col>
                    <Col md="9">
                        <Select
                            value={selectedEntityStatus}
                            onChange={handleEntityStatusChange}
                            options={props.enableAllEntityStatus == true ? editStatusOptions : statusOptions}
                            isDisabled={!props.readyForUse}
                        />
                        {/*todo change this to use "" for label and value*/}
                        <Input type="hidden" value={selectedEntityStatus.value}
                            onChange={(e) => { }}
                            valid={selectedEntityStatus.value != "0" && props.readyForUse}
                            invalid={selectedEntityStatus.value == "0" && props.readyForUse}
                            disabled={true}
                        />
                        <FormFeedback>Entity status is required.</FormFeedback>
                    </Col>
                </Row>
            </FormGroup>

            <Collapse isOpen={reactivateDateFadeIn && props.canReactivate == true}>
                <FormGroup>
                    <Row>
                        <Col>
                            <Label>Reactivation Date:  </Label>
                        </Col>
                        <Col md="9">
                            <DatePicker
                                max={new Date()}
                                value={new Date(props.reactivateDate)}
                                defaultValue={new Date()}
                                onChange={handleReactivationDateChange}
                                valueEditFormat={{ dateStyle: "short" }}
                                dropUp={true}
                                valueDisplayFormat={{ dateStyle: "medium" }} />
                        </Col>
                    </Row>
                </FormGroup>
            </Collapse>

            <Collapse isOpen={dissolvedDateFadeIn}>
                <FormGroup>
                    <Row>
                        <Col>
                            <Label>Dissolution Date:  </Label>
                        </Col>
                        <Col md="9">
                            <DatePicker
                                max={new Date()}
                                value={new Date(props.dissolvedDate)}
                                defaultValue={new Date()}
                                onChange={handleDissolvedDateChange}
                                valueEditFormat={{ dateStyle: "short" }}
                                dropUp={true}
                                valueDisplayFormat={{ dateStyle: "medium" }} />
                        </Col>
                    </Row>
                </FormGroup>
                <FormGroup>
                    <Row>
                        <Col>
                            <Label>Dissolution Reason</Label>
                        </Col>
                        <Col md="9">
                            <Input type="textarea"
                                value={props.statusReason} rows="8"
                                onChange={(e) => props.setStatusReason(e.currentTarget.value)}
                                valid={utilityHelper.isTextPresent(props.statusReason)}
                                invalid={!utilityHelper.isTextPresent(props.statusReason)}
                            />
                            <FormFeedback>Dissolution reason required.</FormFeedback>
                        </Col>
                    </Row>
                </FormGroup>
            </Collapse>
            <Collapse isOpen={inactiveDateFadeIn}>
                <FormGroup>
                    <Row>
                        <Col>
                            <Label>Inactive Date:  </Label>
                        </Col>
                        <Col md="9">
                            <DatePicker
                                max={new Date()}
                                value={new Date(props.inactiveDate)}
                                onChange={handleInactiveDateChange}
                                valueEditFormat={{ dateStyle: "short" }}
                                dropUp={true}
                                valueDisplayFormat={{ dateStyle: "medium" }} />
                        </Col>
                    </Row>
                </FormGroup>
               {/* -Per discussion with A&A a reason is not needed for an entity reactivation nor is it needed for an inactivation*/}
            </Collapse>

            <Collapse isOpen={renamedDateFadeIn}>
                <FormGroup>
                    <Row>
                        <Col>
                            <Label>Name Changed Date:  </Label>
                        </Col>
                        <Col md="9">
                            <DatePicker
                                max={new Date()}
                                value={new Date(props.renamedDate)}
                                defaultValue={new Date()}
                                onChange={handleRenamedDateChange}
                                valueEditFormat={{ dateStyle: "short" }}
                                dropUp={true}
                                valueDisplayFormat={{ dateStyle: "medium" }} />
                        </Col>
                    </Row>
                </FormGroup>
                <FormGroup>
                    <Row>
                        <Col>
                            <Label>Renamed Reason</Label>
                        </Col>
                        <Col md="9">
                            <Input type="textarea"
                                value={props.statusReason} rows="8"
                                onChange={(e) => props.setStatusReason(e.currentTarget.value)}
                                valid={utilityHelper.isTextPresent(props.statusReason)}
                            />
                            {/*<FormFeedback>Renamed reason required.</FormFeedback>*/}
                        </Col>
                    </Row>
                </FormGroup>
            </Collapse>



            <Collapse isOpen={mergedDateFadeIn}>
                <FormGroup>
                    <Row>
                        <Col>
                            <Label>Merged Date:  </Label>
                        </Col>
                        <Col md="9">
                            <DatePicker
                                max={new Date()}
                                value={new Date(props.mergedDate)}
                                defaultValue={new Date()}
                                onChange={handleMergedDateChange}
                                valueEditFormat={{ dateStyle: "short" }}
                                dropUp={true}
                                valueDisplayFormat={{ dateStyle: "medium" }} />
                        </Col>
                    </Row>
                </FormGroup>
                <FormGroup>
                    <Row>
                        <Col>
                            <Label>Merged Reason</Label>
                        </Col>
                        <Col md="9">
                            <Input type="textarea"
                                value={props.statusReason} rows="8"
                                onChange={(e) => props.setStatusReason(e.currentTarget.value)}
                                valid={utilityHelper.isTextPresent(props.statusReason)}
                                invalid={!utilityHelper.isTextPresent(props.statusReason)}
                            />
                            <FormFeedback>Merged reason required.</FormFeedback>
                        </Col>
                    </Row>
                </FormGroup>
            </Collapse>


        </React.Fragment>
    );
}

export default EntityStatusEditor;